import React from 'react';
import { Mail, Linkedin, ArrowUp } from 'lucide-react';
import { companyInfo, services } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-gray-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-baseline gap-1 mb-4">
              <span className="text-3xl font-serif font-bold text-white">D</span>
              <span className="text-3xl font-serif font-bold bg-gradient-to-b from-gray-300 to-gray-500 bg-clip-text text-transparent">M</span>
              <span className="text-3xl font-serif font-bold text-white">G</span>
            </div>
            <p className="text-sm tracking-widest text-gray-400 mb-4">
              DUPONT MANAGEMENT GROUP
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              A global management consultancy delivering transformational insights 
              and strategic leadership across emerging markets.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href={`mailto:${companyInfo.emails.info}`}
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#002060] transition-colors"
              >
                <Mail className="w-5 h-5" />
              </a>
              <a 
                href="#"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#002060] transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.id}>
                  <a 
                    href="#services"
                    onClick={(e) => scrollToSection(e, '#services')}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {service.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="#about"
                  onClick={(e) => scrollToSection(e, '#about')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  About Us
                </a>
              </li>
              <li>
                <a 
                  href="#approach"
                  onClick={(e) => scrollToSection(e, '#approach')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Our Approach
                </a>
              </li>
              <li>
                <a 
                  href="#contact"
                  onClick={(e) => scrollToSection(e, '#contact')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a 
                  href="#contact"
                  onClick={(e) => scrollToSection(e, '#contact')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Request Consultation
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <div className="space-y-4">
              <a 
                href={`mailto:${companyInfo.emails.primary}`}
                className="block text-gray-400 hover:text-white transition-colors text-sm"
              >
                {companyInfo.emails.primary}
              </a>
              <a 
                href={`mailto:${companyInfo.emails.info}`}
                className="block text-gray-400 hover:text-white transition-colors text-sm"
              >
                {companyInfo.emails.info}
              </a>
              <p className="text-gray-400 text-sm">
                Global Operations
              </p>
              <div className="pt-4">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                  <span className="text-sm text-gray-400">24/7 Crisis Response</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500">
              © {currentYear} DuPont Management Group. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-gray-500 hover:text-gray-300 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-gray-300 transition-colors">
                Terms of Service
              </a>
              <button 
                onClick={scrollToTop}
                className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-[#002060] transition-colors"
              >
                <ArrowUp className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
